export default __webpack_public_path__ + "static/media/puzzle2.d2c6b77d.svg";